export const MESSAGE_CENTER_DISMISS_AFTER_MILLIS = 5000
